import React from 'react';

class Zigbee1Icon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_1317)">
          <g filter="url(#filter0_d_241_1317)">
            <path
              d="M56.24 4H23.76C20.3027 4 17.5 6.8027 17.5 10.26V69.74C17.5 73.1973 20.3027 76 23.76 76H56.24C59.6973 76 62.5 73.1973 62.5 69.74V10.26C62.5 6.8027 59.6973 4 56.24 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M40.0001 47.0441C43.8903 47.0441 47.0441 43.8903 47.0441 40.0001C47.0441 36.1098 43.8903 32.9561 40.0001 32.9561C36.1098 32.9561 32.9561 36.1098 32.9561 40.0001C32.9561 43.8903 36.1098 47.0441 40.0001 47.0441Z"
              fill="white"
            />
            <path
              d="M56.2402 3.19995H23.7602C19.8662 3.19995 16.7002 6.36795 16.7002 10.26V69.74C16.7002 73.634 19.8682 76.8 23.7602 76.8H56.2382C60.1322 76.8 63.2982 73.632 63.2982 69.74V10.26C63.2982 6.36595 60.1302 3.19995 56.2382 3.19995H56.2402ZM61.7002 69.74C61.7002 72.752 59.2502 75.2 56.2402 75.2H23.7602C20.7482 75.2 18.3002 72.75 18.3002 69.74V10.26C18.3002 7.24795 20.7502 4.79995 23.7602 4.79995H56.2382C59.2502 4.79995 61.6982 7.24995 61.6982 10.26V69.74H61.7002Z"
              fill="#84827E"
            />
            <path
              d="M53.05 59.1739C53.6984 59.1739 54.224 58.6483 54.224 57.9999C54.224 57.3515 53.6984 56.8259 53.05 56.8259C52.4016 56.8259 51.876 57.3515 51.876 57.9999C51.876 58.6483 52.4016 59.1739 53.05 59.1739Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 32.156C35.6763 32.156 32.1562 35.674 32.1562 40C32.1562 44.326 35.6743 47.844 40.0003 47.844C44.3263 47.844 47.8443 44.326 47.8443 40C47.8443 35.674 44.3263 32.156 40.0003 32.156ZM40.0003 46.244C36.5583 46.244 33.7563 43.444 33.7563 40C33.7563 36.556 36.5563 33.756 40.0003 33.756C43.4443 33.756 46.2443 36.556 46.2443 40C46.2443 43.444 43.4443 46.244 40.0003 46.244Z"
              fill="#84827E"
            />
            <path
              d="M41.5646 37.3079C41.5646 36.4431 40.8639 35.7419 39.9996 35.7419C39.1352 35.7419 38.4346 36.4431 38.4346 37.3079V39.184C38.4346 40.0488 39.1352 40.75 39.9996 40.75C40.8639 40.75 41.5646 40.0488 41.5646 39.184V37.3079Z"
              fill="url(#paint0_linear_241_1317)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_1317"
            x="15.3002"
            y="1.79995"
            width="52.5977"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_1317"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_1317"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_1317"
            x1="38.8748"
            y1="36.1899"
            x2="42.1247"
            y2="38.5197"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_1317">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default Zigbee1Icon;
